
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FinancialAssumptions } from './types';

interface BudgetTabProps {
  assumptions: FinancialAssumptions;
  onInputChange: (section: keyof FinancialAssumptions, field: string, value: string | number) => void;
}

export function BudgetTab({ assumptions, onInputChange }: BudgetTabProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="quarterlyGrowth">Quarterly Growth Rate (%)</Label>
          <Input
            id="quarterlyGrowth"
            type="number"
            value={assumptions.budget.quarterlyGrowthRate}
            onChange={(e) => onInputChange('budget', 'quarterlyGrowthRate', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="seasonalityFactor">Seasonality Factor</Label>
          <Input
            id="seasonalityFactor"
            type="number"
            step="0.1"
            value={assumptions.budget.seasonalityFactor}
            onChange={(e) => onInputChange('budget', 'seasonalityFactor', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="inflationRate">Inflation Rate (%)</Label>
          <Input
            id="inflationRate"
            type="number"
            value={assumptions.budget.inflationRate}
            onChange={(e) => onInputChange('budget', 'inflationRate', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="contingencyReserve">Contingency Reserve (%)</Label>
          <Input
            id="contingencyReserve"
            type="number"
            value={assumptions.budget.contingencyReserve}
            onChange={(e) => onInputChange('budget', 'contingencyReserve', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="performanceTargets">Performance Targets (NZD)</Label>
          <Input
            id="performanceTargets"
            type="number"
            value={assumptions.budget.performanceTargets}
            onChange={(e) => onInputChange('budget', 'performanceTargets', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
